/**
 * Created by zad on 17/11/17.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import i18n from 'react-intl-universal';

import Modal from './Modal';
import styles from './Modal.scss';

class Confirm extends Component {
  static displayName = 'Modal.Confirm';

  static propTypes = {
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    modalClassName: PropTypes.string,
    confirmBodyClassName: PropTypes.string,
    confirmBodyStyle: PropTypes.object,
    destroy: PropTypes.func,
    showCancelBtn: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentWillUnmount() {
    this.props.destroy();
  }

  showModal = () => {
    this.setState((prevState) => {
      if (prevState.visible) {
        return null;
      }
      return {
        visible: true,
      };
    });
  };

  hideModal = () => {
    this.setState({ visible: false });
  };

  handleOk = (e) => {
    this.hideModal();
    const { onOk } = this.props;
    if (_.isFunction(onOk)) {
      onOk(e);
    }
  };

  handleCancel = (e) => {
    this.hideModal();
    const { onCancel } = this.props;
    if (_.isFunction(onCancel)) {
      onCancel(e);
    }
  };

  getButtonText = () => {
    const { okText, cancelText } = this.props;
    return {
      ok: okText || i18n.get('modal.confirm'),
      cancel: cancelText || i18n.get('modal.cancel'),
    };
  };

  render() {
    // eslint-disable-next-line max-len
    const { content, showCancelBtn, modalClassName, confirmBodyClassName, confirmBodyStyle, destroy } = this.props;
    const btnText = this.getButtonText();
    const modalClass = classNames(modalClassName, {
      [`${styles['confirm']}`]: true,
    });
    const bodyClass = classNames(confirmBodyClassName, {
      [`${styles['confirm-body']}`]: true,
    });

    const body = (
      <div className={bodyClass} style={confirmBodyStyle}>
        {content}
      </div>
    );

    const footer = (
      <div className={styles['confirm-footer']}>
        {showCancelBtn && (
          <Modal.Button onClick={this.handleCancel}>
            {btnText.cancel}
          </Modal.Button>
        )}
        <Modal.Button onClick={this.handleOk} type={'primary'}>
          {btnText.ok}
        </Modal.Button>
      </div>
    );

    return (
      <Modal
        {...this.props}
        modalClassName={modalClass}
        visible={this.state.visible}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        afterClose={destroy}
      >
        <div className={styles['confirm-wrapper']}>
          {body}
          {footer}
        </div>
      </Modal>
    );
  }
}

export default function confirm(content, options) {
  return new Promise((resolve) => {
    let called = false;
    const div = document.createElement('div');
    document.body.appendChild(div);

    // 在关闭动画结束时，触发destroy方法
    function destroy() {
      const isRemoved = ReactDOM.unmountComponentAtNode(div);
      if (isRemoved && div.parentNode) {
        div.parentNode.removeChild(div);
      }
    }

    const confirmProps = {
      isMiddle: true,
      showMask: true,
      maskClosable: true,
      width: 312,
      okText: '确认',
      cancelText: '取消',
      onOk: () => undefined,
      onCancel: () => undefined,
      modalClassName: '',
      confirmBodyClassName: '',
      confirmBodyStyle: {},
      showCancelBtn: true,
      ...options,
      title: '',
      showFooter: false,
      closable: false,
      content,
      destroy,
    };

    function ref(instance) {
      if (called) {
        return;
      }
      called = true;
      instance.showModal();
      resolve({
        destroy,
        instance,
        target: div,
      });
    }

    ReactDOM.render(<Confirm {...confirmProps} ref={ref}/>, div);
  });
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalConfirm.js